import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { AnchorButton } from '@blueprintjs/core';
import qs from 'qs';

const LEGEND = [
  { label: 'Unassigned', className: 'unassigned-color' },
  { label: 'Assigned', className: 'assigned-color' },
  { label: 'Confirmed', className: 'confirmed-color' },
  { label: 'In Progress', className: 'in-progress-color' },
  { label: 'Complete', className: 'complete-color' },
];

// Switch between dispatch views plus the job-status legend. Sits in the
// header row of the filter bar on the dispatch board, Jobs and Assignments.
const DispatchViewBar = ({ viewStore, current, status, children }) => {
  const views = [
    {
      key: 'timeline',
      text: 'Timeline',
      icon: 'gantt-chart',
      href: `/dashboard?${qs.stringify(viewStore.CalendarSearchTimeline, { encode: false })}`,
    },
    {
      key: 'week',
      text: 'Week',
      icon: 'timeline-events',
      href: `/dashboard?${qs.stringify(viewStore.CalendarSearchBasicWeek, { encode: false })}`,
    },
    {
      key: 'map',
      text: 'Map',
      icon: 'map',
      href: `/dashboard/map?${qs.stringify(viewStore.dashboardSearch, { encode: false })}`,
    },
    {
      key: 'assignments',
      text: 'Assignments',
      icon: 'th-list',
      href: `/dashboard/assignments?${qs.stringify(viewStore.jobSearch, { encode: false })}`,
    },
    {
      key: 'jobs',
      text: 'Jobs List',
      icon: 'th-list',
      href: `/dashboard/jobs?${qs.stringify(viewStore.jobSearch, { encode: false })}`,
    },
  ];

  return (
    <div className="dispatch-view-bar">
      <nav className="dispatch-view-bar__tabs" aria-label="Dispatch views">
        {views.map(({ key, text, icon, href }) => (
          <AnchorButton
            key={key}
            href={href}
            icon={icon}
            text={text}
            aria-current={key === current ? 'page' : undefined}
            className={key === current ? 'is-current' : undefined}
            style={{ textDecoration: 'none' }}
          />
        ))}
        {children}
      </nav>
      {status && <div className="dispatch-view-bar__status">{status}</div>}
      <div className="dispatch-view-bar__legend">
        {LEGEND.map(({ label, className }) => (
          <span key={label} className="dispatch-view-bar__legend-item">
            <span className={`docs-color-bubble ${className}`} />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};

DispatchViewBar.propTypes = {
  current: PropTypes.oneOf(['timeline', 'week', 'map', 'assignments', 'jobs']),
  status: PropTypes.node,
  children: PropTypes.node,
};

export default inject('viewStore')(observer(DispatchViewBar));
